module.exports = "<div class=\"container-fluid bg-light\">\n  <div class=\"container\">\n    <app-navigation></app-navigation>\n  </div>\n</div>"